function statusFromRapport(rapport, rapportKey) {
  if (!rapport || !rapportKey) return null
  const [category, key] = rapportKey.split('.')
  const entry = rapport?.[category]?.[key]
  if (!entry) return null
  const statut = entry.libelleStatutAdresse || ''
  const concernee = /existant|concerne/i.test(statut) && !/non /i.test(statut)
  return concernee ? 'concerne' : 'non_concerne'
}

const BADGE_STYLES = {
  concerne: 'bg-red-100 text-red-700 border-red-300',
  non_concerne: 'bg-green-100 text-green-700 border-green-300',
  loading: 'bg-slate-100 text-slate-500 border-slate-300',
}

const BADGE_LABELS = {
  concerne: 'CONCERNÉ',
  non_concerne: 'NON CONCERNÉ',
  loading: 'CHARGEMENT...',
}

export default function RiskCard({ title, imageUrl, rapport, rapportKey }) {
  const status = statusFromRapport(rapport, rapportKey) || 'loading'

  return (
    <div className="relative">
      <div className="flex items-center justify-between mb-1">
        <p className="text-xs font-medium text-slate-700 truncate">{title}</p>
        <span className={`text-[10px] font-semibold px-1.5 py-0.5 rounded border ${BADGE_STYLES[status]}`}>
          {BADGE_LABELS[status]}
        </span>
      </div>
      {imageUrl ? (
        <img
          src={imageUrl}
          alt={title}
          className="w-full h-[250px] object-cover rounded-lg"
          loading="lazy"
        />
      ) : (
        <div className="h-[250px] rounded-lg bg-slate-100 animate-pulse flex items-center justify-center">
          <span className="text-xs text-slate-400">Carte en cours de génération...</span>
        </div>
      )}
    </div>
  )
}
